import type { ChatAccessRequest } from '@pixelworld/shared';
import { useEffect, useState } from 'react';
import { da } from '../../i18n/da';
import type { RoomChat } from '../rooms/useRoomConnection';
import styles from './ChatRequests.module.css';

/** For the host of a public room: who asks to write freely, with yes and no (ADR 0011). */
export function ChatRequests({ chat }: { chat: RoomChat }) {
  const [requests, setRequests] = useState<ChatAccessRequest[]>([]);
  useEffect(() => chat.onRequests(setRequests), [chat]);

  if (requests.length === 0) return null;
  return (
    <ul className={styles.requests} aria-live="polite" data-testid="chat-requests">
      {requests.map((request) => (
        <li key={request.playerId} className={styles.request}>
          <span>{da.chat.request(request.displayName)}</span>
          <span className={styles.buttons}>
            <button
              type="button"
              className={styles.allow}
              onClick={() => void chat.decide(request.playerId, true)}
            >
              {da.chat.allow}
            </button>
            <button
              type="button"
              className={styles.deny}
              onClick={() => void chat.decide(request.playerId, false)}
            >
              {da.chat.deny}
            </button>
          </span>
        </li>
      ))}
    </ul>
  );
}
